import { render, staticRenderFns } from "./SaleServiceView.vue?vue&type=template&id=71cbf518&"
import script from "./SaleServiceView.vue?vue&type=script&lang=js&"
export * from "./SaleServiceView.vue?vue&type=script&lang=js&"
import style0 from "./SaleServiceView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports